import React, { useState } from 'react';

import SvgIcon from "../../Icons";

import './index.sass';


const FormikInput = ({ id, icon, error, handleBlur, handleChange, labelPosition, placeholder, required, submitTriggered, touched, type, value }) => {

  const [passwordVisible, setPasswordVisible] = useState(false);
  const [isFocused, setIsFocused] = useState(false);

  const label = `${placeholder}${ required ? '*' : '' }`;
  const isPassword = type === 'password';
  const inputType = (isPassword && passwordVisible) || !type ? 'text' : type;


  return (
    <div className={`form-group ${(error && touched) || (error && submitTriggered) ? 'form-group__error' : ''}${icon ? ' form-group--with-icon' : ''}${isFocused ? ' focused' : ''}`}>
      <label className="form-group__label" htmlFor="company_name">

        { labelPosition === 'top' &&
          <span className="form-group__top-label">
            { label }
          </span>
        }

        <input
          placeholder={!labelPosition ? label : ''}
          name={id}
          type={inputType}
          value={value}
          id={id}
          onChange={handleChange}
          onBlur={(e) => {
            handleBlur(e);
            setIsFocused(false)
          }}
          data-tip={error}
          onFocus={() => setIsFocused(true)}
          className={`form-group__input ${value && 'active'}`}
        />

        { isPassword &&
          <SvgIcon
            className="form-group__password-icon"
            name={passwordVisible ? 'visibility' : 'visibility_off'}
            onClick={() => setPasswordVisible(prevState => !prevState)}
            size={24} />
        }

        { icon || null }

        { labelPosition === 'floating' &&
          <span className={`form-group__floating-label ${value && 'active'}`}>
            { label }
          </span>
        }

      </label>
      <div className="form-group__error-tooltip">{ error }</div>
    </div>
  )
}

export default FormikInput;
